<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 18:09:48
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-loading="isloading" class="my-container">
    <div class="my-title">申请提现</div>
    <div class="my-content">
      <div class="TotalAmount">
        可提现金额（元）：<span class="Amount">{{ Balance }}</span>
        <span style="margin: 0 20px">总余额(元)：{{ FreezeBalance }}</span>
        冻结中(元)：{{ FreezeBalance }}
      </div>
      <el-form
        ref="form"
        :model="form"
        class="sub-form"
        style="margin-top: 30px"
      >
        <div class="relative">
          <el-form-item label="提现金额：" prop="Amount">
            <el-input
              v-model="form.Amount"
              placeholder="请输入提现金额"
              @input="changeVal"
            />
          </el-form-item>
          <span class="tit" @click="setAmout">全部提现</span>
        </div>
        <el-form-item label="银行名称：" prop="BankName">
          <el-input v-model="form.BankName" placeholder="请输入银行名称" />
        </el-form-item>
        <el-form-item label="银行卡号：" prop="BankCardNo">
          <el-input v-model="form.BankCardNo" placeholder="请输入银行卡号" />
        </el-form-item>
        <el-form-item label="真实姓名：" prop="RealName">
          <el-input v-model="form.RealName" placeholder="请输入真实姓名" />
        </el-form-item>
        <el-form-item label=" ">
          <el-button class="submit-btn" @click="submit"> 提交 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { GetUserInfo, GetUserBalance, TxRecord_Add } from "@/api/member";
/* eslint-disable */
export default {
  name: "applyFina",
  data() {
    return {
      isloading: true,
      Balance: 0,
      FreezeBalance: 0,
      TotalBalance: 0,
      form: {
        Amount: "",
        BankName: "",
        BankCardNo: "",
        RealName: "",
      },
    };
  },

  mounted() {
    this.isloading = true;
    GetUserBalance()
      .then((res) => {
        this.isloading = false;
        this.Balance = res.data.Balance;
        this.TotalBalance = res.data.TotalBalance;
        this.FreezeBalance = res.data.FreezeBalance;
      })
      .catch(() => {
        this.isloading = false;
      });
    GetUserInfo()
      .then((res) => {
        this.isloading = false;
        this.form = { ...this.form, ...res.data };
      })
      .catch(() => {
        this.isloading = false;
      });
  },

  methods: {
    changeVal(val) {
      val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      val = val.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      val = val.replace(/^0+\./g, "0.");
      val = val.match(/^0+[1-9]+/) ? (val = val.replace(/^0+/g, "")) : val;
      val = val.match(/^\d*(\.?\d{0,2})/g)[0] || "";
      if (val.includes(".")) {
        let numDian = val.toString().split(".")[1].length;
        if (numDian === 2) {
          this.moneyMaxLeng = val.length;
        }
      } else {
        this.moneyMaxLeng = 8;
      }
      if (Number(val) > this.Balance) {
        this.$message.error("提现金额不能大于可提现余额");
        this.form.Amount = 0;
        return;
      }
      this.form.Amount = val;
    },
    setAmout() {
      this.form.Amount = this.Balance;
    },
    submit() {
      if (this.Balance == 0) {
        this.$message.error("余额不足");
        return;
      }
      if (Number(this.form.Amount) > this.Balance) {
        this.$message.error("提现金额不能大于可提现余额");
        return;
      }
      if (!this.form.Amount) {
        this.$message.error("请输入提现金额");
        return;
      }
      const data = {
        ...this.form,
      };
      TxRecord_Add(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("提交成功");
          this.getInfo(true);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.TotalAmount {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.price {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.sub-form {
  width: 700px;
}
::v-deep .el-input__inner {
  width: 450px;
  height: 46px;
}
::v-deep .el-form-item {
  display: flex;
}
::v-deep .el-form-item__label {
  width: 120px;
}
.width900 {
  width: 900px;
}

.my-container {
  height: 810px;
  .my-title {
    font-size: 18px;
    color: #333333;
    padding: 0 25px;
    height: 68px;
    line-height: 68px;
    background: #ffffff;
    border-radius: 10px;
  }
  .my-content {
    padding: 25px;
    margin-top: 1px;
    height: 810px;
    background: #ffffff;
    border-radius: 10px;
  }
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}

.tit {
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #1c7aff;
}
</style>
